import { Button, CircularProgress, Stack, Typography } from "@mui/material"
import Dialog from "components/common/dialog/dialog"
import ClassStudentsTeacher from "components/module/classStudentsTeacher"
import { useArchivedClassGuard } from "hooks/archivedClassGuard"
import { useClassId } from "hooks/navigation"
import Groups from "pages/groups"
import { useTranslation } from "react-i18next"
import { matchPath, useLocation } from "react-router"
import { RoutePath } from "routes/Route.types"

import StudentsGroupsSwitch from "./StudentsGroupsSwitch"

const TeacherStudentsLayout = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const classId = useClassId()
  const isGroups = !!matchPath(RoutePath.CLASS_GROUPS, pathname)
  const {
    isArchived,
    isRestoring,
    className,
    archivedDate,
    handleRestore,
    handleGoBack,
  } = useArchivedClassGuard()

  return (
    <>
      <div style={{ filter: isArchived ? "blur(5px)" : "none" }}>
        <Stack>
          <StudentsGroupsSwitch
            classId={classId}
            isGroups={isGroups}
            studentsPath={RoutePath.CLASS}
            groupsPath={RoutePath.CLASS_GROUPS}
          />
          {isGroups ? <Groups /> : <ClassStudentsTeacher />}
        </Stack>
      </div>
      <Dialog
        open={isArchived}
        onIconClose={false}
        disableEscapeKeyDown
        onClose={() => undefined}
        tabletMaxWidth="440px"
        titleText={t("addNewClass.thisClassIsArchived")}
        customActionButtonsSlot={null}
      >
        <Stack gap="16px">
          <Stack gap="8px">
            <Typography variant="body2" fontWeight="500" color="mockup.neutral10">
              {t("addNewClass.thisClassIsArchivedDescription", {
                class: className,
              })}
            </Typography>
            {archivedDate && (
              <Typography
                variant="body2"
                fontWeight="600"
                color="mockup.neutral40"
              >
                {t("addNewClass.archivedOn", { date: archivedDate })}
              </Typography>
            )}
          </Stack>

          <Stack
            direction="row"
            justifyContent="flex-end"
            gap="10px"
            pt="16px"
            sx={(theme) => ({
              borderTop: `1px solid ${theme.palette.mockup.primary95}`,
            })}
          >
            <Button variant="outlined" size="small" onClick={handleGoBack}>
              {t("addNewClass.goBack")}
            </Button>
            <Button
              size="small"
              onClick={handleRestore}
              disabled={isRestoring}
            >
              <Stack
                direction="row"
                alignItems="center"
                gap="6px"
                color="common.white"
              >
                {isRestoring && (
                  <CircularProgress size="16px" color="inherit" />
                )}
                {t("addNewClass.restoreAndOpen")}
              </Stack>
            </Button>
          </Stack>
        </Stack>
      </Dialog>
    </>
  )
}

export default TeacherStudentsLayout
